import { Trash2 } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

export function RemoveRowButton({
  label = "Remove",
  className = "",
  ...rest
}: { label?: string } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "type">) {
  return (
    <button
      type="button"
      className={
        "inline-flex size-8 shrink-0 items-center justify-center rounded-lg p-0 text-danger hover:bg-danger/5 " +
        "disabled:cursor-not-allowed disabled:opacity-40 " +
        className
      }
      aria-label={label}
      title={label}
      {...rest}
    >
      <Trash2 className="h-[18px] w-[18px]" aria-hidden />
    </button>
  );
}
